var $47woD$react = require("react");
var $47woD$radixuireactuselayouteffect = require("@radix-ui/react-use-layout-effect");

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $dc478e4659f630c5$exports = {};

$parcel$export($dc478e4659f630c5$exports, "useId", () => $dc478e4659f630c5$export$f680877a34711e37);
$parcel$export($dc478e4659f630c5$exports, "IdProvider", () => $dc478e4659f630c5$export$6be90bcb437e928f);


const $dc478e4659f630c5$var$useReactId = $47woD$react['useId'.toString()] || (()=>undefined
);
let $dc478e4659f630c5$var$count = 0;
function $dc478e4659f630c5$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $47woD$react.useState($dc478e4659f630c5$var$useReactId()); // React versions older than 18 will have client-side ids only.
    $47woD$radixuireactuselayouteffect.useLayoutEffect(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($dc478e4659f630c5$var$count++)
        );
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
} // DEPRECATED
function $dc478e4659f630c5$export$6be90bcb437e928f({ children: children  }) {
    $47woD$react.useEffect(()=>{}, []);
    return /*#__PURE__*/ $47woD$react.createElement($47woD$react.Fragment, null, children);
}
const $dc478e4659f630c5$var$ID_PROVIDER_DEPRECATED = `Warning: The \`IdProvider\` has been deprecated. For details, see https://radix-ui.com/docs/primitives/utilities/id-provider`;


$parcel$exportWildcard(module.exports, $dc478e4659f630c5$exports);


//# sourceMappingURL=index.js.map
